/* Quello che una persona manda al salvataggio: l'indirizzo, e la partita
   IVA con codice destinatario e PEC. Il modulo ha in mano la riga intera, e
   mandarla tutta riscriverebbe anche nome e codice fiscale con quello che
   c'era - una riga in piu' nel registro per niente, e la porta aperta a
   cambiarli da qui. Un campo vuoto parte vuoto e il server lo salva NULL,
   come prima della partita IVA: un campo che non cambia non scrive niente
   nel registro. */
export const CAMPI_PERSONA = ['indirizzo', 'cap', 'citta', 'provincia', 'nazione', 'partita_iva', 'codice_univoco', 'pec'];
/* IL CODICE FISCALE DI UNA PERSONA (Alex, 3/10/2026 sera, D3 risposta 2):
   «Modifica» lo completa se manca o non e' valido - lo dice il server,
   codice_fiscale_completabile, con la regola che usa quando salva - e parte
   solo se e' stato scritto: un campo lasciato com'era non tocca niente. Un
   codice valido lo corregge l'amministrazione, a parte, col motivo. */
/* La casella «L'intestatario è il paziente» (Alex, 6/10/2026): parte
   SOLO se la persona l'ha toccata (_casella_toccata: un clic sulla casella o
   su «Confermo»). Partire vuol dire confermarla, e il server toglie il segno
   «da controllare» della proposta della 305: se partisse sempre, chi cambia
   solo l'indirizzo confermerebbe senza guardare e il filtro «Da controllare»
   si svuoterebbe in silenzio (Alex, 6/10 sera). */
export const soloCampiPersona = (f) => ({
    ...Object.fromEntries(CAMPI_PERSONA.map((k) => [k, f[k] ?? ''])),
    ...(f._casella_toccata ? { e_il_paziente: f.e_il_paziente === true } : {}),
    ...(f.codice_fiscale_completabile && (f.codice_fiscale || '') !== f._cf_iniziale
        ? { codice_fiscale: f.codice_fiscale || '' } : {}),
});
